import type WebApiClient from "../../api/WebApiClient.js";
import { createReducer } from "../redux-utils.js";
import { createErrorHandler } from "@/app-utils/errors.ts";
import { type ServerStatusInfo } from "@/graphql.ts";
import {
  LOAD_SYSTEM_DETAILS_FAILURE,
  LOAD_SYSTEM_DETAILS_REQUEST,
  LOAD_SYSTEM_DETAILS_SUCCESS,
} from "@/redux/action-types.ts";

export interface ISystemAdminState {
  isLoadingSystemDetails: boolean;
  systemDetails: ServerStatusInfo;
}

const initialState: ISystemAdminState = {
  isLoadingSystemDetails: false,
  systemDetails: null,
};

/**
 * Reducers
 */
export default createReducer(initialState, {
  [LOAD_SYSTEM_DETAILS_REQUEST]: (state: ISystemAdminState) => {
    return {
      ...state,
      isLoadingSystemDetails: true,
    };
  },
  [LOAD_SYSTEM_DETAILS_SUCCESS]: (state: ISystemAdminState, systemDetails: ServerStatusInfo) => {
    return {
      ...state,
      isLoadingSystemDetails: false,
      systemDetails: systemDetails,
    };
  },
  [LOAD_SYSTEM_DETAILS_FAILURE]: (state: ISystemAdminState) => {
    return {
      ...state,
      isLoadingSystemDetails: false,
    };
  },
});

/**
 * Action creators
 */

export function loadSystemDetails(systemId: string) {
  return (dispatch, _getState, webApiClient: WebApiClient) => {
    dispatch({
      type: LOAD_SYSTEM_DETAILS_REQUEST,
    });

    return webApiClient
      .fetchSystemDetails(systemId)
      .then((systemDetails: ServerStatusInfo) => {
        dispatch({
          type: LOAD_SYSTEM_DETAILS_SUCCESS,
          payload: systemDetails,
        });
      })
      .catch(
        createErrorHandler(dispatch, {
          actionType: LOAD_SYSTEM_DETAILS_FAILURE,
          alertTitle: "Fetching of System Details Failed",
        }),
      );
  };
}
